/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_DetailsInputs */

const en_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Details`)
};

const es_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del anuncio`)
};

const fr_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de l'annonce`)
};

const de_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-Details`)
};

const ja_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品詳細`)
};

const zh_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品详情`)
};

const ar_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل الإعلان`)
};

const id_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Listing`)
};

const it_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli Annuncio`)
};

const ru_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали объявления`)
};

const pt_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do Anúncio`)
};

const ko_listing_details = /** @type {(inputs: Listing_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 상세 정보`)
};

/**
* | output |
* | --- |
* | "Listing Details" |
*
* @param {Listing_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_details = /** @type {((inputs?: Listing_DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_details(inputs)
	if (locale === "es") return es_listing_details(inputs)
	if (locale === "fr") return fr_listing_details(inputs)
	if (locale === "de") return de_listing_details(inputs)
	if (locale === "ja") return ja_listing_details(inputs)
	if (locale === "zh") return zh_listing_details(inputs)
	if (locale === "ar") return ar_listing_details(inputs)
	if (locale === "id") return id_listing_details(inputs)
	if (locale === "it") return it_listing_details(inputs)
	if (locale === "ru") return ru_listing_details(inputs)
	if (locale === "pt") return pt_listing_details(inputs)
	return ko_listing_details(inputs)
});